module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/3/5-ac65c4abfb6a4060494cdeed1ada3c3b.jpg";